import qs from 'node:querystring'

import { FAPI_PRODUCT_ENDPOINT, FAPI_TREE_ENDPOINT } from '@/libs/constants/b2bFapiApiEndpoints'
import environment from '@/environments/environment.dev'

import HttpClient from './apiHttpClient'

const apiClient = new HttpClient(environment.shopFAPIUrl)

export const ProductService = {
  async requestProductDetailByLang(materialNumber: string) {
    return apiClient.get(`${FAPI_PRODUCT_ENDPOINT}/${materialNumber}/details`)
  },

  async requestCategoryPath(categoryId) {
    return apiClient.get(`${FAPI_PRODUCT_ENDPOINT}/categorypath`, {
      params: {
        categoryId,
      },
    })
  },

  async getComparisonDetails(listMaterialNumber = []) {
    const queryParameters = listMaterialNumber.join('&materialNumber=')

    return apiClient.get(`${FAPI_PRODUCT_ENDPOINT}/compare?materialNumber=${queryParameters}`)
  },

  async getSubmenuProductCategoryList() {
    return apiClient.get(`${FAPI_TREE_ENDPOINT}/navigation-menu`)
  },

  async getCategoryInfo(categoryIds) {
    return apiClient.get(`${FAPI_TREE_ENDPOINT}/category-without-product`, {
      params: {
        categoryIds,
      },
      paramsSerializer: {
        serialize: (parameters) => qs.stringify(parameters),
      },
    })
  },

  async getProductInfo(materialNumbers) {
    return apiClient.get(`${FAPI_PRODUCT_ENDPOINT}/material-name`, {
      params: {
        materialNumbers,
      },
      paramsSerializer: {
        serialize: (parameters) => qs.stringify(parameters),
      },
    })
  },

  async getClassTypesAndProductCount(categoryId: string, sortOrder = 0) {
    return apiClient.get(`${FAPI_TREE_ENDPOINT}/category`, {
      params: {
        categoryId,
        sortOrder,
        pageSize: 1,
      },
    })
  },

  async getProductsByClassType(categoryId, pageNumber, sortOrder, pageSize) {
    return apiClient.get(`${FAPI_TREE_ENDPOINT}/category`, {
      params: {
        categoryId,
        sortOrder,
        pageSize,
        pageNumber,
      },
    })
  },

  async getProductSubCategoryOverviewData(categoryId) {
    return apiClient.get(`${FAPI_TREE_ENDPOINT}/category`, {
      params: {
        categoryId,
      },
    })
  },

  async getMachineServiceFAQs(materialNumber) {
    return apiClient.get(`${FAPI_PRODUCT_ENDPOINT}/${materialNumber}/servicefaqs`)
  },

  async getBasicProductInfo(materialNumber = '') {
    return apiClient.get(`${FAPI_PRODUCT_ENDPOINT}/${materialNumber}`)
  },

  async getPromotionProducts() {
    try {
      const { data } = await apiClient.get(`${FAPI_PRODUCT_ENDPOINT}/promotion`)
      return data
    } catch (error) {
      console.error('Error fetching promotion products:', error)
      throw new Error('Failed to fetch promotion products')
    }
  },

  async getMatchingProducts(productType, materialNumber, pageNumber, sortOrder = 2, pageSize = 12) {
    return apiClient.get(`${FAPI_PRODUCT_ENDPOINT}/${materialNumber}/${productType}`, {
      params: {
        pageNumber,
        pageSize,
        sortOrder,
      },
    })
  },

  async getProductSpareParts(materialNumber: string, sessionId?: string) {
    return apiClient.get(`${FAPI_PRODUCT_ENDPOINT}/${materialNumber}/disis`, {
      params: {
        sessionId,
      },
    })
  },

  async getDisisHomePageLink(sessionId: string) {
    return apiClient.get(`${FAPI_PRODUCT_ENDPOINT}/disis`, {
      params: {
        sessionId,
      },
    })
  },
}
